import axios from 'axios'
// import router from './router'

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND
})

// Add a request interceptor
instance.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('jwt')
        if (token) {
            config.headers.Authorization = token
        } else {
            // router.push({ name: 'ErrorPage' }, () => {})
        }

        config.headers['Accept-Language'] = localStorage.getItem('lang')

        return config
    },
    error => {
        Promise.reject(error)
    }
)

export default instance
